import React, { useState } from "react";
import VideoHero from "../video-hero";

function BannerInner({
  className = "",
  videoPath,
  children,
  actorCount,
}) {
  // Function to determine the text based on the actor count
  const actorText = actorCount > 1 ? "Actor portrayals" : "Actor portrayal";
  const [isPlaying, setIsPlaying] = useState(true);

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <>
      <div className={`banner-inner hero-video ${className}`}>
        <div className="banner-info-wrapper">
          <div className="centered-content border-wrap">
            <div className="svg-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1398 48"
                fill="none"
                className="cta-svg"
              >
                <path
                  d="M2 47.464C2 2 47.4054 2 47.4054 2L1397.5 2"
                  stroke="#90D21F"
                  strokeWidth="4"
                />
              </svg>
            </div>
            <div className="banner-inner__content">{children}</div>
          </div>
        </div>
        {videoPath && (
          <div>
            <div className="centered-content">
              <div className="play-pause-btn desktop-only">
                <button onClick={handlePlayPause} aria-label={isPlaying ? "Pause video" : "Play video"}>
                  {!isPlaying ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                    >
                      <circle
                        cx="24"
                        cy="24"
                        r="24"
                        fill="black"
                        fillOpacity="0.5"
                      />
                      <polygon points="18,12 18,36 36,24" fill="white" />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                    >
                      <circle
                        cx="24"
                        cy="24"
                        r="24"
                        fill="black"
                        fillOpacity="0.5"
                      />
                      <rect x="15" y="12" width="6" height="24" fill="white" />
                      <rect x="27" y="12" width="6" height="24" fill="white" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
            <div className="actor-text">{actorText}.</div>
          </div>
        )}
        {videoPath && <VideoHero videoSrc={videoPath} isPlaying={isPlaying} />}
      </div>
    </>
  );
}

export default BannerInner;